import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { isNil } from 'lodash';
import { toaster } from 'Helpers/index';

import { authActionStatusAtom, authErrorAtom } from 'Recoil/auth.atom';
import { authResetPassword } from 'Services/auth.services';
import ResetPasswordForm from 'Components/auth/reset-password-form';

import './reset-password.scss';

const ResetPasswordPage = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const [status, setStatus] = useRecoilState<any>(authActionStatusAtom);
  const [error, setError] = useRecoilState<any>(authErrorAtom);

  const handleSubmit = async ({ passToken, newPassword }: { passToken: string; newPassword: string; }) => {
    setStatus({ ...status, resetPassword: 'loading' });
      const responseData = await authResetPassword({ passToken, newPassword });

      if (!isNil(responseData.error)) {
        setStatus({ ...status, resetPassword: 'error' });
        setError(responseData?.error);
      }
      else {
        setStatus({ ...status, resetPassword: 'success' });

        toaster(
          'success',
          <div dangerouslySetInnerHTML={{ __html: t('txt.resetPasswordSuccess') }} />
        )
      }
  }

  const handleAfterSuccess = () => {
    setStatus({ ...status, resetPassword: 'idle', verifyEmail: 'idle' });
    history.push('/login');
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>{t('pageTitle.resetPassword')}</title>
        <meta name="robots" content="noindex"/>
      </Helmet>

      <div className="reset-password-page">
        <div className="reset-password-page--header">

        </div>

        <div className="reset-password-page--main">
          <div className="reset-password-page--container">
            <div className="reset-password-page--form">
              <div className="reset-password-page--form-title">
                <h3>{t('title.resetPassword')}</h3>
              </div>

              <div
                className="reset-password-page--form-description"
                dangerouslySetInnerHTML={{ __html: t('txt.resetPassword') }}
              />

              <ResetPasswordForm
                status={
                  status.verifyEmail === 'idle' || status.verifyEmail === 'success'
                    ? status.resetPassword : status.verifyEmail
                }
                onSubmit={handleSubmit}
                afterSuccess={handleAfterSuccess}
              />
            </div>
            <div className="reset-password-page--bot"></div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ResetPasswordPage;
